import { Control, FieldValues, Path, useController } from 'react-hook-form'

import { noBorder } from '@/stories/view/layouts/area/Area.stories'

import CodeTextarea from '@/components/view/atoms/textarea/CodeTextare'

interface Props<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  error?: boolean
  placeholder?: string
  height?: string
  disabled?: boolean
  noBorder?: boolean
}

const FormCodeTextArea = <T extends FieldValues>({
  control,
  name,
  error = false,
  placeholder,
  height,
  disabled = false,
  noBorder = false
}: Props<T>) => {
  const { field } = useController({ control, name })

  return (
    <CodeTextarea
      value={field.value ?? ''}
      onChange={field.onChange}
      error={error}
      placeholder={placeholder}
      height={height}
      disabled={disabled}
      noBorder={noBorder}
    />
  )
}

export default FormCodeTextArea
